import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Swal from "sweetalert2";
import Select from 'react-select';
import AttendanceServices from '../../../services/AttendanceServices'
import ReviewAttendanceModal from "./ReviewAttendanceModal";


const PendingAttendance = () => {
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(true);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState([]);
    const [run, setRun] = useState(0);
    const [sort, setSort] = useState(20); // Number of items per page
    const activePag = useRef(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [test, setTest] = useState(0);
    const [selectedAttendance, setSelectedAttendance] = useState(null);
    const [showApprovalModal, setShowApprovalModal] = useState(false);


    useEffect(() => {

        const fetchPendingAttendance = async () => {

            try {

                setLoading(true);

                const response =
                    await AttendanceServices.getAttendanceByStatus(
                        "checkOut",
                        "pending"
                    );

                setData(response?.data || []);

            } catch (error) {

                console.log(error);

                setError(error);

                Swal.fire(
                    "Error",
                    "Failed to load attendance records",
                    "error"
                );

            } finally {

                setLoading(false);

            }

        };

        fetchPendingAttendance();

    }, [run]);



    // Options for row selections
    const options = [
        { value: '5', label: '5' },
        { value: '10', label: '10' },
        { value: '20', label: '20' },
        { value: '50', label: '50' },
        { value: '100', label: '100' }
    ];

    const filteredSearch = data.filter(item =>
        item?.driver?.name
            ?.toLowerCase()
            ?.includes(searchTerm.toLowerCase()) ||

        item?.store?.name
            ?.toLowerCase()
            ?.includes(searchTerm.toLowerCase()) ||

        item?.vehicle?.asset?.equipmentNo
            ?.toLowerCase()
            ?.includes(searchTerm.toLowerCase())
    );


    // Calculate total pages
    const pagination = Math.ceil(filteredSearch.length / sort);

    // Handle page click
    const onClick = (i) => {
        activePag.current = i;
        setTest(i);
    };



    return (
        <>

            <ReviewAttendanceModal
                show={showApprovalModal}
                handleClose={() => setShowApprovalModal(false)}
                attendance={selectedAttendance}
                setRun={setRun}
            />
            {loading && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(255,255,255,0.7)",
                        zIndex: 99999,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <div className="text-center">

                        <div
                            className="spinner-border text-primary"
                            role="status"
                            style={{
                                width: "4rem",
                                height: "4rem"
                            }}
                        />

                        <div
                            className="mt-3 fw-bold"
                            style={{
                                fontSize: "18px"
                            }}
                        >
                            Loading Attendance...
                        </div>

                    </div>
                </div>
            )}

            <div className="row">
                <div className="col-xl-12">
                    <div className="filter cm-content-box box-primary">
                        <div className={`content-title`}>
                            <div className="cpa">
                                <i className="fas fa-filter me-2"></i>Filter
                            </div>
                            <div className="tools">
                                <Link to="#" className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`}
                                    onClick={() => setOpen(!open)}
                                >
                                    <i className="fas fa-angle-up"></i>
                                </Link>
                            </div>
                        </div>
                        <Collapse in={open}>
                            <div className="cm-content-body form excerpt">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-xl-3 col-xxl-6">
                                            <input type="text"
                                                className="form-control mb-xl-0 mb-3"
                                                id="exampleFormControlInput1"
                                                placeholder="Search"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-xl-3 col-xxl-6">
                                            <Select
                                                placeholder="Select row to display in User Table"
                                                value={options.find(option => option.value === sort)} // set the current selected value
                                                onChange={(selectedOption) => setSort(selectedOption.value)} // update `sort` on selection
                                                isSearchable={false}
                                                options={options}
                                                className="custom-react-select mb-3 mb-xxl-0"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </div>
                    <div className="filter cm-content-box box-primary">
                        <div className={`content-title`}>
                            <div className="cpa">
                                <i className="fa fa-list me-2" aria-hidden="true"></i>Pending Attendance
                                <span className="badge bg-warning ms-2">
                                    {filteredSearch.length}
                                </span>
                            </div>
                            <div className="tools">
                                <Link
                                    to="#"
                                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                    onClick={() => setOpen2(!open2)}
                                >
                                    <i className="fas fa-angle-up"></i>
                                </Link>
                            </div>
                        </div>
                        <Collapse in={open2}>
                            <div className="cm-content-body form excerpt">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div id="content_wrapper" className="dataTables_wrapper no-footer">
                                            <div style={{
                                                overflowX: 'auto',
                                                overflowY: 'auto',
                                                maxHeight: '400px',
                                                whiteSpace: 'nowrap',
                                                position: 'relative',   // ✅ ADD THIS
                                                zIndex: 0               // ✅ ADD THIS
                                            }}>
                                                <table
                                                    className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                                                    id="pending-attendance-data"
                                                >
                                                    <thead
                                                        style={{
                                                            position: "sticky",
                                                            top: 0,
                                                            backgroundColor: "#fff", // White background
                                                            zIndex: 1,
                                                        }}
                                                    >
                                                        <tr>
                                                            <th>S.No</th>
                                                            <th>Store</th>
                                                            <th>Part No</th>
                                                            <th>Description</th>
                                                            <th>Equipment No</th>
                                                            <th>Driver</th>
                                                            <th>Start KM</th>
                                                            <th>End KM</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {filteredSearch.length > 0 ? (

                                                            filteredSearch
                                                                .slice(
                                                                    activePag.current * sort,
                                                                    (activePag.current + 1) * sort
                                                                )
                                                                .map((item, index) => (

                                                                    <tr key={item._id}>

                                                                        <td>
                                                                            {activePag.current * sort + index + 1}
                                                                        </td>
                                                                        <td className="scrollable-description">
                                                                            {item?.store?.name || "-"}
                                                                        </td>

                                                                        <td>
                                                                            {item?.vehicle?.asset?.masterItem?.partNo || "-"}
                                                                        </td>

                                                                        <td className="scrollable-description">
                                                                            {item?.vehicle?.asset?.masterItem?.description || "-"}
                                                                        </td>

                                                                        <td>
                                                                            {item?.vehicle?.asset?.equipmentNo || "-"}
                                                                        </td>

                                                                        <td>
                                                                            {item?.driver?.name || "-"}
                                                                        </td>

                                                                        <td>
                                                                            {item?.startKM || 0}
                                                                        </td>

                                                                        <td>
                                                                            {item?.endKM || 0}
                                                                        </td>

                                                                        <td>
                                                                            <span className="badge light badge-warning">
                                                                                {item?.approvalStatus}
                                                                            </span>
                                                                        </td>

                                                                        <td>
                                                                            <button
                                                                                className="btn btn-success btn-sm"
                                                                                onClick={() => {
                                                                                    setSelectedAttendance(item);
                                                                                    setShowApprovalModal(true);
                                                                                }}
                                                                            >
                                                                                <i className="fas fa-check me-1"></i>
                                                                                Review
                                                                            </button>
                                                                        </td>

                                                                    </tr>

                                                                ))

                                                        ) : (

                                                            <tr>
                                                                <td colSpan="9" className="text-center">
                                                                    No Pending Attendance Found
                                                                </td>
                                                            </tr>

                                                        )}

                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info">
                                                    Showing {activePag.current * sort + 1} to{" "}
                                                    {Math.min(filteredSearch.length, (activePag.current + 1) * sort)}
                                                    of {filteredSearch.length}
                                                </div>
                                                <div className="dataTables_paginate paging_simple_numbers">
                                                    <Link
                                                        className="paginate_button previous"
                                                        to="#"
                                                        onClick={() =>
                                                            activePag.current > 0 && onClick(activePag.current - 1)
                                                        }
                                                    >
                                                        <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                                                    </Link>
                                                    <span>
                                                        {Array.from({ length: pagination }, (_, i) => (
                                                            <Link
                                                                key={i}
                                                                to="#"
                                                                className={`paginate_button ${activePag.current === i ? "current" : ""}`}
                                                                onClick={() => onClick(i)}
                                                            >
                                                                {i + 1}
                                                            </Link>
                                                        ))}
                                                    </span>
                                                    <Link
                                                        className="paginate_button next"
                                                        to="#"
                                                        onClick={() =>
                                                            activePag.current < pagination - 1 && onClick(activePag.current + 1)
                                                        }
                                                    >
                                                        <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PendingAttendance;
